<div class="file-upload-list">
    <div class="file-upload-item row">
      <div class="col-md-9 ps-0">
        <div class="file-name text-truncate">
          {{fileName}}
          <button class="btn btn-icon btn-remove btn-sm">
            <img
             *ngIf="fileName"
              src="../assets/images/icons/remove-icon.png"
              alt=""
              aria-hidden="true"
              (click)="onFileReset()"
            />
          </button>
        </div>
      </div>
      <div class="col-3" *ngIf="isEditPermission">
        <label
          class="
            btn d-block w-100 btn-file-upload btn-icon-success
            mb-0
          "
        >
        <input
          #fileInput
          type="file"
          id="{{uniqueID}}"
          style="display: none"
          (change)="onFileChange($event)"
        />
          {{'Upload'|translate}}
          <img
            src="../assets/images/icons/upload-icon.png"
            alt=""
            aria-hidden="true"
            (click)="onUploadBtnClick()"
          />
        </label>
      </div>
    </div>
  </div>